export default interface feedback {
  feedback: boolean;
  isError: boolean;
  color: string | null;
  text: string | null;
}

const feedbackInitialValue: feedback = {
  feedback: false,
  isError: false,
  color: '',
  text: '',
};

export { feedbackInitialValue };
